import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabListenerComponent } from './lab-listener/lab-listener.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [LabListenerComponent],
  declarations: [LabListenerComponent]
})
export class ServerListenersModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/server-listeners/server-listeners.module.ts